import React from 'react';
import PropTypes from 'prop-types';
import {Switch, Route, Redirect} from 'react-router-dom';
import {connect} from 'react-redux';
import Dashboard from './Dashboard';
import Question from './Question';
import Quiz from './Quiz';
import Settings from './Account/Settings';
import Users from './Users';


const Routes = () => (
    <Switch>
        <Route path="/quizzes" component={Quiz}/>
        <Route path="/questions" component={Question}/>
        {/*<Route path="/dashboard" component={Dashboard}/>*/}
        <Route path="/users" component={Users}/>
        <Route path="/settings" component={Settings}/>
        <Redirect to="/quizzes"/>
    </Switch>
);

Routes.propTypes = {
    user: PropTypes.shape({
        role: PropTypes.string.isRequired,
    }).isRequired,
};

export default connect(
    ({account: {user}}) => ({
        user,
    }),
    null
)(Routes);
